// Utils
import cn from '../../../utils/cn';
// Styles
import styles from './DefaultHeader.module.css';

/**
 * DefaultHeader component for displaying header content with text overflow handling
 * @param {object} props - Component props
 * @param {React.ReactNode} props.children - Content to display
 * @param {string} [props.title] - Title to display
 * @param {string} [props.className] - Additional CSS classes
 * @returns {JSX.Element} DefaultHeader component
 */
export default function DefaultHeader({
  children,
  title,
  className,
}) {
  return (
    <div className={cn([styles['default-header'], className])} title={title}>
      {children}
    </div>
  );
}
